// Checklist - PERLAI (about)

page.checklist.perlai = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    check: function(){
        this.reset();
        if(page.v.firstLoad) this.first();

        if($('#apie-prl-cvs').length > 0){
            log.page("CHECK: Perlai detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){

        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);

        var i = 0;
        this.v.cvs = document.getElementById("apie-prl-cvs");
        this.v.ctx = this.v.cvs.getContext("2d");
        page.main.v.marketSticky.play();
        
        this.trigger(7);
        this.resize();
        var that = this;
        $(`.apie-prl-txt.txt0`).mouseover(function () { 
            that.trigger(0);
        });
        $(`.apie-prl-txt.txt1`).mouseover(function () { 
            that.trigger(1);
        });
        $(`.apie-prl-txt.txt2`).mouseover(function () { 
            that.trigger(2);
        });
        $(`.apie-prl-txt.txt3`).mouseover(function () { 
            that.trigger(3);
        });
        $(`.apie-prl-txt.txt4`).mouseover(function () { 
            that.trigger(4);
        });
        $(`.apie-prl-txt.txt5`).mouseover(function () { 
            that.trigger(5);
        });
        $(`.apie-prl-txt.txt6`).mouseover(function () { 
            that.trigger(6);
        });
        $(`.apie-prl-txt`).mouseleave(function () { 
            that.trigger(7);
        });

        $('.circle-hover').mouseover(function(e){
            let $this = $(this);
            let target = $this.data('target');
            $(target).addClass('circle-hovered');
        }).mouseleave(function(e){
            $('.svg-circle').removeClass('circle-hovered');
        })

    },
    first: function(){

    },
    unload: function(){
        $(`.apie-prl-txt.txt0`).off("mouseover");
        $(`.apie-prl-txt.txt1`).off("mouseover");
        $(`.apie-prl-txt.txt2`).off("mouseover");
        $(`.apie-prl-txt.txt3`).off("mouseover");
        $(`.apie-prl-txt.txt4`).off("mouseover");
        $(`.apie-prl-txt.txt5`).off("mouseover");
        $(`.apie-prl-txt.txt6`).off("mouseover");
        $(`.apie-prl-txt`).off("mouseleave");
    },
    fadein: function(){

    },
    fadeout: function(){

    },
    trigger: function(no=2){
        var vr = this.v;
        let bo = this.v.bubbleO;
        let lo = this.v.lineO;
        if(bo[no].state == 1 || vr.target == no) return;
        vr.target = no;
        vr.triggered = true;
        vr.animating = true;
        $.each(bo, function(k,v){
            TweenMax.killTweensOf(v);
            if(k == no){
                v.state = 1;
                TweenMax.to(v, 1, {grad: 10, colorProps:{color:'rgb(11,210,131)'}, ease:Expo.easeOut, onComplete: function(e){
                    console.log("animation stop");
                    console.log(vr);
                    vr.animating = false;
                }});
            }else if(v.state == 1){
                v.state = 2;
                TweenMax.to(v, 0.5, {grad: 0, colorProps:{color:'rgb(74,93,131)'}, ease:Expo.easeOut});
            }else if( v.state == 2){
                //TweenMax.set(v, {grad: 0, colorProps:{color:'rgb(74,93,131)'}});
                v.state = 0;
                v.grad = 0;
                v.color = 'rgb(74,93,131)';
            }
        });
        $.each(lo, function(k,v){
            TweenMax.killTweensOf(v);
            var active = false;
            $.each(vr.bline[no], function(id, va){
                if(k == va) active = true;
            });
            if(active){
                if(v.state != 1){
                    v.state = 1;
                    TweenMax.to(v, 0.6, {colorProps:{color:'rgb(11,210,131)'}, ease:Expo.easeOut});
                }
            }else if(v.state == 1){
                v.state = 2;
                TweenMax.to(v, 0.4, {colorProps:{color:'rgb(74,93,131)'}, ease:Expo.easeOut});
            }else if( v.state == 2){
                //TweenMax.set(v, {grad: 0, colorProps:{color:'rgb(74,93,131)'}});
                v.state = 0;
                v.color = 'rgb(74,93,131)';
            }
        });
    },
    calc: function(){
        if(this.v.triggered){
            this.v.triggered = false;
            this.v.animating = true;
        }
        //console.log("Animating: ", this.v.animating);
        if(!this.v.animating) return;
        if(this.v.resized){
            this.v.resized = false;
            this.v.animating = false;
        }
        log.page("PERLAI: calc");
        var pav = this.v;
        var cvs = pav.cvs;
        /** @type {CanvasRenderingContext2D} */
        var ctx =  pav.ctx;
        var loc =  pav.loc;
        var line = pav.line;
        var i=0;
        ctx.clearRect(0,0,cvs.width,cvs.height);
        if(pav.drawLines){
            for(i=0;i<line.length; i++){
                var p=[[loc[line[i][0]][0],loc[line[i][0]][1]+ line[i][2]],[loc[line[i][1]][0],loc[line[i][1]][1]+ line[i][3]]];

                ctx.save();
                ctx.strokeStyle = pav.lineO[i].color;
                ctx.beginPath();
                ctx.moveTo(p[0][0], p[0][1]);
                ctx.lineTo(p[1][0], p[1][1]);
                ctx.closePath();
                ctx.stroke();
                ctx.restore();
            }
        }
        
        for(i=0;i<loc.length;i++){
            if(pav.bubbleO[i].grad > 0){
                let grad = ctx.createRadialGradient(loc[i][0], loc[i][1], loc[i][2]-40 + pav.bubbleO[i].grad, loc[i][0], loc[i][1], loc[i][2] + pav.bubbleO[i].grad);
                grad.addColorStop(0, 'rgba(11,210,131,1)');
                grad.addColorStop(1, 'rgba(11,210,131,0)');
                
                ctx.arc(loc[i][0], loc[i][1], loc[i][2] + pav.bubbleO[i].grad, 0, 2 * Math.PI);
                
                ctx.fillStyle = grad;
                ctx.fill(); //${Math.lerp(0.2,1,tpl)}
            }
            ctx.fillStyle = pav.bubbleO[i].color;
            
            ctx.beginPath();
            ctx.moveTo(loc[i][0], loc[i][1]);
            ctx.arc(   loc[i][0], loc[i][1], loc[i][2], 0, Math.PI * 2);
            ctx.closePath();
            ctx.fill();
            ctx.globalCompositeOperation = 'destination-out';
            ctx.fillStyle = "white";
            ctx.beginPath();
            ctx.moveTo(loc[i][0], loc[i][1]);
            ctx.arc(   loc[i][0], loc[i][1], loc[i][2] - 2, 0, Math.PI * 2);
            ctx.closePath();
            ctx.fill();
            ctx.globalCompositeOperation = 'source-over';
            
            var txt = $(`.apie-prl-txt.txt${i}`);
            
            if(pav.bubbleO[i].grad > 5){
                txt.addClass("txt-active");
            }else{
                txt.removeClass("txt-active");
            }
            txt.css("left", loc[i][0]);
            txt.css("top", loc[i][1]);
            txt.css("transform", `translate(-50%, -50%)`);
        }
    },
    calc2: function(){
        var pavt = this.v.trans;
        var cTime = performance.now();
        pavt.dTime = (cTime - pavt.oTime)/1000;
        pavt.oTime = cTime;
        var dTime = pavt.dTime;

        if(pavt.val >= pavt.duration){
            pavt.waitVal -= dTime;
            if(pavt.waitVal <= 0){
                pavt.waitVal = pavt.wait;
                pavt.val = 0;
                pavt.cid++;
                if(pavt.cid > this.v.seq.length-1){
                    pavt.cid = 0;
                }
            }
        }else{
            pavt.val += dTime;
            if(pavt.val > pavt.duration){
                pavt.val = pavt.duration;
            }
        }

        var pav = this.v;
        var oid = pav.seq[pav.trans.cid][0];
        var lid = pav.seq[pav.trans.cid][1];
        var nid = pav.seq[pav.trans.cid+1>=this.v.seq.length?0:this.v.trans.cid+1][0];
        var cid = pav.trans.val > pav.trans.duration/2?nid:oid;
        var tp = pav.trans.val / pav.trans.duration;
        var tph = Math.sin(tp*Math.PI);
        var tpl = Math.abs((tp*2)-1);
        //var cid = 0;
        var cvs = pav.cvs;
        /** @type {CanvasRenderingContext2D} */
        var ctx =  pav.ctx;
        var loc =  pav.loc;
        var line = pav.line;
        var i=0;
        ctx.clearRect(0,0,cvs.width,cvs.height);
        if(pav.drawLines){
            ctx.strokeStyle = "#4a5d83";
            for(i=0;i<line.length; i++){
                var p=[[loc[line[i][0]][0],loc[line[i][0]][1]+ line[i][2]],[loc[line[i][1]][0],loc[line[i][1]][1]+ line[i][3]]];
                //console.log(p);
                ctx.save();
                /* if(lid == i){
                    ctx.lineWidth = Math.lerp(1.1,2,tph);
                //rgb(11,210,131)
                    //ctx.strokeStyle = `rgba(${Math.lerp(255,11,tph)}, ${Math.lerp(255,210,tph)}, ${Math.lerp(255,131,tph)}, ${Math.lerp(0.2,1,tph)})`;
                }else{
                    ctx.lineWidth = 1.1;
                //rgb(11,210,131)
                    //ctx.strokeStyle = `rgba(255,255,255,0.2)`;
                } */
                
                ctx.beginPath();
                ctx.moveTo(p[0][0], p[0][1]);
                ctx.lineTo(p[1][0], p[1][1]);
                ctx.closePath();
                ctx.stroke();
                ctx.restore();
            }
        }
        
        for(i=0;i<loc.length;i++){
            if(i==cid){
                
                let grad = ctx.createRadialGradient(loc[i][0], loc[i][1], loc[i][2]-30, loc[i][0], loc[i][1], loc[i][2] + tpl*10);
                grad.addColorStop(0, 'rgba(11,210,131,1)');
                grad.addColorStop(1, 'rgba(11,210,131,0)');
                
                ctx.arc(loc[i][0], loc[i][1], loc[i][2] + tpl*20, 0, 2 * Math.PI);
                
                ctx.fillStyle = grad;
                ctx.fill(); //${Math.lerp(0.2,1,tpl)}
                ctx.fillStyle = `rgb(${Math.lerp(74,11,tpl)}, ${Math.lerp(93,210,tpl)}, ${Math.lerp(131,131,tpl)})`;
            }else{
                //ctx.fillStyle = "rgba(255, 255, 255, 0.2)";
                // 74  93  131
                ctx.fillStyle = "#4a5d83";
            }
            
            ctx.beginPath();
            ctx.moveTo(loc[i][0], loc[i][1]);
            ctx.arc(   loc[i][0], loc[i][1], loc[i][2], 0, Math.PI * 2);
            ctx.closePath();
            ctx.fill();
            ctx.globalCompositeOperation = 'destination-out';
            ctx.fillStyle = "white";
            ctx.beginPath();
            ctx.moveTo(loc[i][0], loc[i][1]);
            ctx.arc(   loc[i][0], loc[i][1], loc[i][2] - 2, 0, Math.PI * 2);
            ctx.closePath();
            ctx.fill();
            ctx.globalCompositeOperation = 'source-over';
            
            /* var md = pav.animRadius;
            var dist = Math.hypot(loc[i][3], loc[i][4]);
            var dmd = (dist/md)*pav.animSpeed;
            if(dmd < md/1000) dmd = md/1000;
            if(dist > md){
                var ang = Math.atan2(loc[i][4], loc[i][3]);
                loc[i][3] = Math.cos(ang) * md;
                loc[i][4] = Math.sin(ang) * md;
            }
            loc[i][5] += Math.sin(Math.random()*6.28)*0.1;
            loc[i][3] += Math.cos(loc[i][5]) * dmd;
            loc[i][4] += Math.sin(loc[i][5]) * dmd; */
            //console.log(dist + " : " + md + " = " + dist/md);
            var txt = $(`.apie-prl-txt.txt${i}`);
            //txt.css("color", i==cid?"#0bd283":"white");
            if(cid==i && tph < 0.5){
                txt.addClass("txt-active");
            }else{
                txt.removeClass("txt-active");
            }
            txt.css("left", loc[i][0]);
            txt.css("top", loc[i][1]);
            txt.css("transform", `translate(-50%, -50%)`);
        }

    },
    resize: function(){
        var i = 0;
        var pav = this.v;

        if(window.innerWidth <= 540){
            let pct = Math.clamp(window.innerWidth / 420, 0, 1);
            $(".apie-prl-cnt").css({
                "overflow": "visible",
                "transform-origin": "top left",
                "transform": `scale(${pct})`,
                "height": `${Math.round(1900*pct)}px`,
                "width": `${Math.round(420*pct)}px`
            });
            pav.drawLines = false;
            pav.cvs.width = 420;
            pav.cvs.height = 1900;
            for(i = 0; i < pav.loc.length; i++){
                pav.loc[i][0] = pav.res[2][i][0];
                pav.loc[i][1] = pav.res[2][i][1];
                //page.about.v.loc[i][2] = page.about.v.res[2][i][2];
            }
        }else if(window.innerWidth <= 1400){
            $(".apie-prl-cnt").removeAttr('style');

           var pct = (window.innerWidth - 540) / 860;

            
            pav.drawLines = window.innerWidth>960;


            pav.cvs.width =  Math.round(Math.lerp(540,1400,pct));
            pav.cvs.height = Math.round(Math.lerp(1500,760,pct));

            pct *= pct;
            var pl = pav.loc;
            pl[0][0] = Math.round(Math.lerp(pl[0][2] + 60,pav.res[0][0][0],pct));
            pl[0][1] = Math.round(Math.lerp(pl[0][2] + 60,pav.res[0][0][1],pct));

            pl[2][0] = Math.round(Math.lerp(pav.cvs.width * 0.44,pav.res[0][2][0],pct));
            pl[2][1] = Math.round(Math.lerp(pav.cvs.height * 0.25,pav.res[0][2][1],pct));

            pl[1][0] = Math.round(Math.lerp(pav.cvs.width * 0.25,pav.res[0][1][0],pct));
            pl[1][1] = Math.round(Math.lerp(pav.cvs.height * 0.5,pav.res[0][1][1],pct));

            pl[3][0] = Math.round(Math.lerp(pav.cvs.width * 0.7,pav.res[0][3][0],pct));
            pl[3][1] = Math.round(Math.lerp(pav.cvs.height * 0.4,pav.res[0][3][1],pct));

            pl[4][0] = Math.round(Math.lerp(pav.cvs.width * 0.4,pav.res[0][4][0],pct));
            pl[4][1] = Math.round(Math.lerp(pav.cvs.height - pl[4][2] - 60 - pav.cvs.height * 0.02,pav.res[0][4][1],pct));

            pl[5][0] = Math.round(Math.min(Math.lerp(pav.cvs.width - pl[5][2] - 60,pav.res[0][5][0],pct),pav.cvs.width - pl[5][2] - 60));
            pl[5][1] = Math.round(Math.lerp(pl[5][2] + 60,pav.res[0][5][1],pct));

            pl[6][0] = Math.min(Math.round(Math.lerp(pav.cvs.width - pl[6][2] - 60,pav.res[0][6][0],pct * 0.4)),Math.round(pav.cvs.width - pl[6][2] - 60));
            pl[6][1] = Math.round(Math.lerp(pav.cvs.height * 0.65,pav.res[0][6][1],pct));
            //for(i = 0; i < page.about.v.loc.length; i++){
                //page.about.v.loc[i][0] = Math.round(Math.lerp(page.about.v.res[2][i][0],page.about.v.res[0][i][0],pct));
                //page.about.v.loc[i][1] = Math.round(Math.lerp(page.about.v.res[2][i][1],page.about.v.res[0][i][1],pct));
                //page.about.v.loc[i][2] = Math.round(Math.lerp(page.about.v.res[2][i][2],page.about.v.res[0][i][2],pct));
            //}
        }else{
            $(".apie-prl-cnt").removeAttr('style');
            pav.drawLines = true;
            pav.cvs.width = 1400;
            pav.cvs.height = 760;
            for(i = 0; i < pav.loc.length; i++){
                pav.loc[i][0] = pav.res[0][i][0];
                pav.loc[i][1] = pav.res[0][i][1];
                //page.about.v.loc[i][2] = page.about.v.res[0][i][2];
            }
        }

        if(!this.v.animating){
            this.v.animating = true;
            this.v.resized = true;
        }

        var sProp = window.innerHeight / window.innerWidth;

        if(sProp < 0.5425){
            $(".apie-prl-cnt").css("transform", `scale(${sProp/0.5625})`);
           // $(".apie-prl-cnt").css("transform", `scale(${sProp/0.7825})`);

        }/*else{
            $(".apie-prl-cnt").css("transform", `scale(1)`);
        }*/



    },
    scroll: function(){

    },
    v:{
        cvs: null,
        ctx: null,
        triggered: false,
        target: 0,
        animating: false,
        resized: false,
        bubbleSpeed: 4000, // Perlo bangavimo greitis
        animRadius: 10, // Perlo judėjimo spindulys pixeliais nuo pradinio taško
        animSpeed: 0.1, // Perlo judėjimo greitis
        trans: {
            wait: 4, // Perlo laukimo laikas tarp transitionu
            duration: 1, // Perlo transition laikas

            waitVal: 4,
            val: 1,
            cid: 0,
            oTime: 0,
            dTime: 0
        },
        stars: {
            rotSpeed: 0.05,
            duration: 0.7,
            
            pos:{
                wait: [2,2,2],
                x:[0,0,0],
                y:[0,0,0],
                waitVal: [Math.random()*3,Math.random()*3,Math.random()*3],
                val: [1,1,1],
                rotation: [Math.random()*6.28,Math.random()*6.28,Math.random()*6.28]
            }
        },
        drawLines: true,
        loc: [
            [337, 176, 95.5 ,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28], 
            [255, 484, 152.5,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28], 
            [608, 354, 137.5,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28], 
            [882, 258, 91.5 ,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28], 
            [821, 578, 129.5,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28], 
            [1148,153, 84.5 ,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28], 
            [1157,437, 128  ,Math.random()*6.28 ,Math.random()*6.28 ,Math.random()*6.28]
        ],
        res: [
            [
                [337, 176, 95.5 ],
                [255, 484, 152.5],
                [608, 354, 137.5],
                [882, 258, 91.5 ],
                [821, 578, 129.5],
                [1148,153, 84.5 ],
                [1157,437, 128  ]
            ],
            [
                [337 , 176, 95.5 ],
                [255 , 484, 152.5],
                [608 , 354, 137.5],
                [882 , 258, 91.5 ],
                [821 , 578, 129.5],
                [1148, 153, 84.5 ],
                [1157, 437, 128  ]
            ],
            [
                [150 , 150, 95.5 ],
                [210 , 430, 152.5],
                [220 , 750, 137.5],
                [150 , 1000, 91.5 ],
                [220 , 1240, 129.5],
                [150, 1470, 84.5 ],
                [220, 1700, 128  ]
            ]
        ],
        line: [
            [0,1, 32 ,-62],
            [0,2, -52, 28],
            [0,3, -21,-19],
            [1,2, 0  ,-16],
            [1,4, 28 , 0 ],
            [2,3, 0  ,-4 ],
            [2,4, 0  , 0 ],
            [2,6, 11 , 0 ],
            [3,4, -48, 0 ],
            [4,5, -21,-14],
            [4,6, 36 ,-21],
            [5,6, 0  , 0 ]
        ],
        bline: [
            [0,1,2],
            [0,3,4],
            [1,3,5,6,7],
            [2,5,8],
            [4,6,8,9,10],
            [9,11],
            [7,10,11],
            []
        ],
        lineO: [
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0},
            {color: "rgb(74,93,131)", state: 0}
        ],
        bubbleO: [
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0},
            {color: "rgb(74,93,131)", grad: 0, state: 0}
        ],
        seq: [
            [0,0],
            [1,3],
            [2,5],
            [3,8],
            [4,9],
            [5,11],
            [6,10],
            [4,6],
            [2,5],
            [3,2]
        ]
    }
}